import { apiClient } from "@/lib/apiClient";
import type { Company } from "../types";
import type { ApiResponse } from "@/types/apiResponse";

export const createCompany = (payload: Company) => {
	return apiClient<ApiResponse>("/v1/empresa", {
		method: "POST",
		body: payload,
	});
};
